export const worksheetsStateTests = [
  // State Tests Grade 3
  {
    id: 'state-g3-operations',
    title: 'Grade 3 State Test: Operations',
    description: 'Practice multiplication, division, and multi-step word problems for state assessments.',
    grade: 'Grade 3',
    subject: 'Test Prep',
    topic: 'Operations',
    difficulty: 'Intermediate',
    pages: 8,
    isFree: false,
    downloadUrl: '/downloads/state-g3-operations.pdf',
    thumbnailUrl: 'https://public.readdy.ai/ai/img_res/2dc15407150441da4f876328f4ac5f80.jpg'
  },
  {
    id: 'state-g3-fractions',
    title: 'Grade 3 State Test: Fractions',
    description: 'Master fraction concepts and representations for grade 3 state tests.',
    grade: 'Grade 3',
    subject: 'Test Prep',
    topic: 'Fractions',
    difficulty: 'Intermediate',
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/state-g3-fractions.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=third%20grade%20fractions%20state%20test%20worksheet%20with%20fraction%20models%2C%20number%20lines%2C%20comparing%20fractions%2C%20standardized%20test%20format%2C%20multiple%20choice%20questions%2C%20professional%20design%2C%20clean%20background&width=400&height=500&seq=st302&orientation=portrait'
  },
  {
    id: 'state-g3-geometry',
    title: 'Grade 3 State Test: Geometry',
    description: 'Review shapes, area, perimeter, and measurement for state assessments.',
    grade: 'Grade 3',
    subject: 'Test Prep',
    topic: 'Geometry',
    difficulty: 'Intermediate',
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/state-g3-geometry.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=third%20grade%20geometry%20state%20test%20worksheet%20with%20shapes%2C%20area%20and%20perimeter%20problems%2C%20measurement%20questions%2C%20standardized%20test%20format%2C%20professional%20assessment%20layout%2C%20clean%20white%20background&width=400&height=500&seq=st303&orientation=portrait'
  },
  {
    id: 'state-g3-data',
    title: 'Grade 3 State Test: Data and Graphs',
    description: 'Practice reading and interpreting graphs and data for state tests.',
    grade: 'Grade 3',
    subject: 'Test Prep',
    topic: 'Data',
    difficulty: 'Intermediate',
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/state-g3-data.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=third%20grade%20data%20and%20graphs%20state%20test%20worksheet%20with%20bar%20graphs%2C%20pictographs%2C%20data%20tables%2C%20interpretation%20questions%2C%20standardized%20test%20format%2C%20professional%20design%2C%20clean%20organized%20background&width=400&height=500&seq=st304&orientation=portrait'
  },
  {
    id: 'state-g3-practice',
    title: 'Grade 3 State Test: Full Practice',
    description: 'Complete grade 3 state test practice covering all math standards.',
    grade: 'Grade 3',
    subject: 'Test Prep',
    topic: 'Full Test',
    difficulty: 'Intermediate',
    pages: 12,
    isFree: false,
    downloadUrl: '/downloads/state-g3-practice.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=third%20grade%20full%20state%20test%20practice%20booklet%20cover%20with%20official%20standardized%20test%20format%2C%20comprehensive%20math%20assessment%2C%20answer%20sheet%2C%20professional%20test%20design%2C%20clean%20background&width=400&height=500&seq=st305&orientation=portrait'
  },

  // State Tests Grade 4
  {
    id: 'state-g4-multi-digit',
    title: 'Grade 4 State Test: Multi-Digit Operations',
    description: 'Practice multi-digit multiplication and division for state assessments.',
    grade: 'Grade 4',
    subject: 'Test Prep',
    topic: 'Operations',
    difficulty: 'Intermediate',
    pages: 8,
    isFree: false,
    downloadUrl: '/downloads/state-g4-multi-digit.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=fourth%20grade%20state%20test%20worksheet%20with%20multi%20digit%20multiplication%20and%20division%2C%20long%20division%20problems%2C%20standardized%20test%20format%2C%20multiple%20choice%20options%2C%20professional%20assessment%20design%2C%20clean%20layout&width=400&height=500&seq=st401&orientation=portrait'
  },
  {
    id: 'state-g4-fractions-decimals',
    title: 'Grade 4 State Test: Fractions and Decimals',
    description: 'Master fraction operations and decimal concepts for grade 4 state tests.',
    grade: 'Grade 4',
    subject: 'Test Prep',
    topic: 'Fractions',
    difficulty: 'Intermediate',
    pages: 8,
    isFree: false,
    downloadUrl: '/downloads/state-g4-fractions-decimals.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=fourth%20grade%20fractions%20and%20decimals%20state%20test%20worksheet%20with%20fraction%20operations%2C%20decimal%20place%20value%2C%20visual%20models%2C%20standardized%20test%20format%2C%20professional%20design%2C%20clean%20white%20background&width=400&height=500&seq=st402&orientation=portrait'
  },
  {
    id: 'state-g4-measurement',
    title: 'Grade 4 State Test: Measurement',
    description: 'Review angles, area, perimeter, and unit conversions for state assessments.',
    grade: 'Grade 4',
    subject: 'Test Prep',
    topic: 'Measurement',
    difficulty: 'Intermediate',
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/state-g4-measurement.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=fourth%20grade%20measurement%20state%20test%20worksheet%20with%20angles%2C%20protractors%2C%20area%20perimeter%20problems%2C%20unit%20conversions%2C%20standardized%20test%20format%2C%20professional%20assessment%20layout%2C%20clean%20background&width=400&height=500&seq=st403&orientation=portrait'
  },
  {
    id: 'state-g4-geometry',
    title: 'Grade 4 State Test: Geometry',
    description: 'Practice geometric shapes, symmetry, and coordinate planes for state tests.',
    grade: 'Grade 4',
    subject: 'Test Prep',
    topic: 'Geometry',
    difficulty: 'Intermediate',
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/state-g4-geometry.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=fourth%20grade%20geometry%20state%20test%20worksheet%20with%20shapes%2C%20lines%20of%20symmetry%2C%20coordinate%20grids%2C%20classification%20problems%2C%20standardized%20test%20format%2C%20professional%20design%2C%20clean%20organized%20background&width=400&height=500&seq=st404&orientation=portrait'
  },
  {
    id: 'state-g4-practice',
    title: 'Grade 4 State Test: Full Practice',
    description: 'Complete grade 4 state test practice covering all math standards.',
    grade: 'Grade 4',
    subject: 'Test Prep',
    topic: 'Full Test',
    difficulty: 'Intermediate',
    pages: 14,
    isFree: false,
    downloadUrl: '/downloads/state-g4-practice.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=fourth%20grade%20full%20state%20test%20practice%20booklet%20with%20comprehensive%20math%20assessment%2C%20standardized%20test%20format%2C%20answer%20bubbles%2C%20professional%20test%20design%2C%20clean%20white%20background&width=400&height=500&seq=st405&orientation=portrait'
  },

  // State Tests Grade 5
  {
    id: 'state-g5-decimals',
    title: 'Grade 5 State Test: Decimal Operations',
    description: 'Master all operations with decimals for grade 5 state assessments.',
    grade: 'Grade 5',
    subject: 'Test Prep',
    topic: 'Decimals',
    difficulty: 'Intermediate',
    pages: 8,
    isFree: false,
    downloadUrl: '/downloads/state-g5-decimals.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=fifth%20grade%20decimal%20operations%20state%20test%20worksheet%20with%20addition%20subtraction%20multiplication%20division%20of%20decimals%2C%20standardized%20test%20format%2C%20multiple%20choice%20questions%2C%20professional%20design%2C%20clean%20layout&width=400&height=500&seq=st501&orientation=portrait'
  },
  {
    id: 'state-g5-fractions-advanced',
    title: 'Grade 5 State Test: Advanced Fractions',
    description: 'Practice multiplying and dividing fractions for state tests.',
    grade: 'Grade 5',
    subject: 'Test Prep',
    topic: 'Fractions',
    difficulty: 'Intermediate',
    pages: 8,
    isFree: false,
    downloadUrl: '/downloads/state-g5-fractions-advanced.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=fifth%20grade%20advanced%20fractions%20state%20test%20worksheet%20with%20multiplication%20and%20division%20of%20fractions%2C%20mixed%20numbers%2C%20visual%20models%2C%20standardized%20test%20format%2C%20professional%20assessment%20design%2C%20clean%20background&width=400&height=500&seq=st502&orientation=portrait'
  },
  {
    id: 'state-g5-volume',
    title: 'Grade 5 State Test: Volume',
    description: 'Calculate volume of rectangular prisms for grade 5 state assessments.',
    grade: 'Grade 5',
    subject: 'Test Prep',
    topic: 'Volume',
    difficulty: 'Intermediate',
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/state-g5-volume.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=fifth%20grade%20volume%20state%20test%20worksheet%20with%20rectangular%20prisms%2C%20unit%20cubes%2C%20volume%20formulas%2C%20three%20dimensional%20shapes%2C%20standardized%20test%20format%2C%20professional%20design%2C%20clean%20white%20background&width=400&height=500&seq=st503&orientation=portrait'
  },
  {
    id: 'state-g5-coordinate-plane',
    title: 'Grade 5 State Test: Coordinate Plane',
    description: 'Practice graphing and coordinate plane problems for state tests.',
    grade: 'Grade 5',
    subject: 'Test Prep',
    topic: 'Graphing',
    difficulty: 'Intermediate',
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/state-g5-coordinate-plane.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=fifth%20grade%20coordinate%20plane%20state%20test%20worksheet%20with%20x%20and%20y%20axes%2C%20plotting%20points%2C%20ordered%20pairs%2C%20graphing%20problems%2C%20standardized%20test%20format%2C%20professional%20assessment%20layout%2C%20clean%20background&width=400&height=500&seq=st504&orientation=portrait'
  },
  {
    id: 'state-g5-practice',
    title: 'Grade 5 State Test: Full Practice',
    description: 'Complete grade 5 state test practice covering all math standards.',
    grade: 'Grade 5',
    subject: 'Test Prep',
    topic: 'Full Test',
    difficulty: 'Intermediate',
    pages: 14,
    isFree: false,
    downloadUrl: '/downloads/state-g5-practice.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=fifth%20grade%20full%20state%20test%20practice%20booklet%20cover%20with%20comprehensive%20math%20assessment%2C%20standardized%20test%20format%2C%20answer%20sheet%2C%20professional%20test%20design%2C%20clean%20organized%20background&width=400&height=500&seq=st505&orientation=portrait'
  },

  // State Tests Grade 6
  {
    id: 'state-g6-ratios-proportions',
    title: 'Grade 6 State Test: Ratios and Proportions',
    description: 'Master ratios, rates, and proportional relationships for state assessments.',
    grade: 'Grade 6',
    subject: 'Test Prep',
    topic: 'Ratios',
    difficulty: 'Intermediate',
    pages: 8,
    isFree: false,
    downloadUrl: '/downloads/state-g6-ratios-proportions.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=sixth%20grade%20ratios%20and%20proportions%20state%20test%20worksheet%20with%20ratio%20tables%2C%20unit%20rates%2C%20proportional%20relationships%2C%20standardized%20test%20format%2C%20multiple%20choice%20options%2C%20professional%20design%2C%20clean%20layout&width=400&height=500&seq=st601&orientation=portrait'
  },
  {
    id: 'state-g6-expressions',
    title: 'Grade 6 State Test: Expressions and Equations',
    description: 'Practice algebraic expressions and one-step equations for state tests.',
    grade: 'Grade 6',
    subject: 'Test Prep',
    topic: 'Algebra',
    difficulty: 'Intermediate',
    pages: 8,
    isFree: false,
    downloadUrl: '/downloads/state-g6-expressions.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=sixth%20grade%20algebra%20state%20test%20worksheet%20with%20expressions%2C%20variables%2C%20one%20step%20equations%2C%20solving%20for%20x%2C%20standardized%20test%20format%2C%20professional%20assessment%20design%2C%20clean%20white%20background&width=400&height=500&seq=st602&orientation=portrait'
  },
  {
    id: 'state-g6-geometry-area',
    title: 'Grade 6 State Test: Geometry and Area',
    description: 'Review area of polygons and surface area for grade 6 state assessments.',
    grade: 'Grade 6',
    subject: 'Test Prep',
    topic: 'Geometry',
    difficulty: 'Intermediate',
    pages: 8,
    isFree: false,
    downloadUrl: '/downloads/state-g6-geometry-area.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=sixth%20grade%20geometry%20state%20test%20worksheet%20with%20polygons%2C%20area%20formulas%2C%20surface%20area%20of%20prisms%2C%20labeled%20dimensions%2C%20standardized%20test%20format%2C%20professional%20design%2C%20clean%20background&width=400&height=500&seq=st603&orientation=portrait'
  },
  {
    id: 'state-g6-statistics',
    title: 'Grade 6 State Test: Statistics',
    description: 'Practice data analysis and statistical measures for state tests.',
    grade: 'Grade 6',
    subject: 'Test Prep',
    topic: 'Statistics',
    difficulty: 'Intermediate',
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/state-g6-statistics.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=sixth%20grade%20statistics%20state%20test%20worksheet%20with%20data%20displays%2C%20mean%20median%20mode%2C%20box%20plots%2C%20histograms%2C%20standardized%20test%20format%2C%20professional%20assessment%20layout%2C%20clean%20organized%20background&width=400&height=500&seq=st604&orientation=portrait'
  },
  {
    id: 'state-g6-practice',
    title: 'Grade 6 State Test: Full Practice',
    description: 'Complete grade 6 state test practice covering all math standards.',
    grade: 'Grade 6',
    subject: 'Test Prep',
    topic: 'Full Test',
    difficulty: 'Intermediate',
    pages: 15,
    isFree: false,
    downloadUrl: '/downloads/state-g6-practice.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=sixth%20grade%20full%20state%20test%20practice%20booklet%20with%20comprehensive%20math%20assessment%2C%20standardized%20test%20format%2C%20answer%20bubbles%2C%20professional%20test%20design%2C%20clean%20white%20background&width=400&height=500&seq=st605&orientation=portrait'
  },

  // State Tests Grade 7
  {
    id: 'state-g7-proportional',
    title: 'Grade 7 State Test: Proportional Relationships',
    description: 'Master proportional relationships and linear equations for state assessments.',
    grade: 'Grade 7',
    subject: 'Test Prep',
    topic: 'Proportions',
    difficulty: 'Intermediate',
    pages: 8,
    isFree: false,
    downloadUrl: '/downloads/state-g7-proportional.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=seventh%20grade%20proportional%20relationships%20state%20test%20worksheet%20with%20graphs%2C%20tables%2C%20equations%2C%20constant%20of%20proportionality%2C%20standardized%20test%20format%2C%20professional%20design%2C%20clean%20layout&width=400&height=500&seq=st701&orientation=portrait'
  },
  {
    id: 'state-g7-equations-inequalities',
    title: 'Grade 7 State Test: Equations and Inequalities',
    description: 'Practice multi-step equations and inequalities for state tests.',
    grade: 'Grade 7',
    subject: 'Test Prep',
    topic: 'Algebra',
    difficulty: 'Intermediate',
    pages: 8,
    isFree: false,
    downloadUrl: '/downloads/state-g7-equations-inequalities.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=seventh%20grade%20equations%20and%20inequalities%20state%20test%20worksheet%20with%20multi%20step%20problems%2C%20number%20lines%2C%20solving%20equations%2C%20standardized%20test%20format%2C%20professional%20assessment%20design%2C%20clean%20background&width=400&height=500&seq=st702&orientation=portrait'
  },
  {
    id: 'state-g7-geometry-circles',
    title: 'Grade 7 State Test: Geometry',
    description: 'Review circles, angles, and geometric constructions for grade 7 state assessments.',
    grade: 'Grade 7',
    subject: 'Test Prep',
    topic: 'Geometry',
    difficulty: 'Intermediate',
    pages: 8,
    isFree: false,
    downloadUrl: '/downloads/state-g7-geometry-circles.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=seventh%20grade%20geometry%20state%20test%20worksheet%20with%20circles%2C%20circumference%2C%20area%2C%20angle%20relationships%2C%20geometric%20constructions%2C%20standardized%20test%20format%2C%20professional%20design%2C%20clean%20white%20background&width=400&height=500&seq=st703&orientation=portrait'
  },
  {
    id: 'state-g7-probability',
    title: 'Grade 7 State Test: Probability',
    description: 'Practice probability and statistical inference for state tests.',
    grade: 'Grade 7',
    subject: 'Test Prep',
    topic: 'Probability',
    difficulty: 'Intermediate',
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/state-g7-probability.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=seventh%20grade%20probability%20state%20test%20worksheet%20with%20sample%20spaces%2C%20tree%20diagrams%2C%20compound%20events%2C%20statistical%20inference%2C%20standardized%20test%20format%2C%20professional%20assessment%20layout%2C%20clean%20background&width=400&height=500&seq=st704&orientation=portrait'
  },
  {
    id: 'state-g7-practice',
    title: 'Grade 7 State Test: Full Practice',
    description: 'Complete grade 7 state test practice covering all math standards.',
    grade: 'Grade 7',
    subject: 'Test Prep',
    topic: 'Full Test',
    difficulty: 'Intermediate',
    pages: 15,
    isFree: false,
    downloadUrl: '/downloads/state-g7-practice.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=seventh%20grade%20full%20state%20test%20practice%20booklet%20cover%20with%20comprehensive%20math%20assessment%2C%20standardized%20test%20format%2C%20answer%20sheet%2C%20professional%20test%20design%2C%20clean%20organized%20background&width=400&height=500&seq=st705&orientation=portrait'
  },

  // State Tests Grade 8
  {
    id: 'state-g8-linear-functions',
    title: 'Grade 8 State Test: Linear Functions',
    description: 'Master linear equations, slope, and graphing for state assessments.',
    grade: 'Grade 8',
    subject: 'Test Prep',
    topic: 'Linear Functions',
    difficulty: 'Advanced',
    pages: 9,
    isFree: false,
    downloadUrl: '/downloads/state-g8-linear-functions.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=eighth%20grade%20linear%20functions%20state%20test%20worksheet%20with%20coordinate%20planes%2C%20slope%2C%20y%20intercept%2C%20graphing%20lines%2C%20standardized%20test%20format%2C%20professional%20design%2C%20clean%20layout&width=400&height=500&seq=st801&orientation=portrait'
  },
  {
    id: 'state-g8-systems',
    title: 'Grade 8 State Test: Systems of Equations',
    description: 'Practice solving systems of equations for grade 8 state tests.',
    grade: 'Grade 8',
    subject: 'Test Prep',
    topic: 'Systems',
    difficulty: 'Advanced',
    pages: 8,
    isFree: false,
    downloadUrl: '/downloads/state-g8-systems.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=eighth%20grade%20systems%20of%20equations%20state%20test%20worksheet%20with%20two%20equations%2C%20graphing%20method%2C%20substitution%2C%20elimination%2C%20standardized%20test%20format%2C%20professional%20assessment%20design%2C%20clean%20white%20background&width=400&height=500&seq=st802&orientation=portrait'
  },
  {
    id: 'state-g8-functions',
    title: 'Grade 8 State Test: Functions',
    description: 'Review function concepts and representations for state assessments.',
    grade: 'Grade 8',
    subject: 'Test Prep',
    topic: 'Functions',
    difficulty: 'Advanced',
    pages: 8,
    isFree: false,
    downloadUrl: '/downloads/state-g8-functions.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=eighth%20grade%20functions%20state%20test%20worksheet%20with%20function%20notation%2C%20input%20output%20tables%2C%20graphs%2C%20domain%20and%20range%2C%20standardized%20test%20format%2C%20professional%20design%2C%20clean%20background&width=400&height=500&seq=st803&orientation=portrait'
  },
  {
    id: 'state-g8-geometry-pythagorean',
    title: 'Grade 8 State Test: Geometry',
    description: 'Practice Pythagorean theorem and transformations for state tests.',
    grade: 'Grade 8',
    subject: 'Test Prep',
    topic: 'Geometry',
    difficulty: 'Advanced',
    pages: 8,
    isFree: false,
    downloadUrl: '/downloads/state-g8-geometry-pythagorean.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=eighth%20grade%20geometry%20state%20test%20worksheet%20with%20right%20triangles%2C%20Pythagorean%20theorem%2C%20transformations%2C%20coordinate%20geometry%2C%20standardized%20test%20format%2C%20professional%20assessment%20layout%2C%20clean%20background&width=400&height=500&seq=st804&orientation=portrait'
  },
  {
    id: 'state-g8-practice',
    title: 'Grade 8 State Test: Full Practice',
    description: 'Complete grade 8 state test practice covering all math standards.',
    grade: 'Grade 8',
    subject: 'Test Prep',
    topic: 'Full Test',
    difficulty: 'Advanced',
    pages: 16,
    isFree: false,
    downloadUrl: '/downloads/state-g8-practice.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=eighth%20grade%20full%20state%20test%20practice%20booklet%20with%20comprehensive%20math%20assessment%2C%20standardized%20test%20format%2C%20answer%20bubbles%2C%20professional%20test%20design%2C%20clean%20white%20background&width=400&height=500&seq=st805&orientation=portrait'
  },

  // SHSAT Prep
  {
    id: 'shsat-arithmetic',
    title: 'SHSAT Math: Arithmetic',
    description: 'Master arithmetic operations and number sense for SHSAT exam.',
    grade: 'SHSAT Prep',
    subject: 'Test Prep',
    topic: 'Arithmetic',
    difficulty: 'Advanced',
    pages: 10,
    isFree: false,
    downloadUrl: '/downloads/shsat-arithmetic.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=SHSAT%20test%20prep%20worksheet%20with%20arithmetic%20problems%2C%20number%20operations%2C%20fractions%20decimals%20percents%2C%20official%20SHSAT%20style%20format%2C%20professional%20test%20layout%2C%20clean%20organized%20background&width=400&height=500&seq=shsat01&orientation=portrait'
  },
  {
    id: 'shsat-algebra',
    title: 'SHSAT Math: Algebra',
    description: 'Practice algebraic expressions, equations, and word problems for SHSAT.',
    grade: 'SHSAT Prep',
    subject: 'Test Prep',
    topic: 'Algebra',
    difficulty: 'Advanced',
    pages: 10,
    isFree: false,
    downloadUrl: '/downloads/shsat-algebra.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=SHSAT%20algebra%20worksheet%20with%20equations%2C%20expressions%2C%20word%20problems%2C%20systems%2C%20official%20SHSAT%20format%2C%20professional%20test%20design%2C%20clean%20white%20background&width=400&height=500&seq=shsat02&orientation=portrait'
  },
  {
    id: 'shsat-geometry',
    title: 'SHSAT Math: Geometry',
    description: 'Review geometry concepts including area, volume, and coordinate geometry for SHSAT.',
    grade: 'SHSAT Prep',
    subject: 'Test Prep',
    topic: 'Geometry',
    difficulty: 'Advanced',
    pages: 10,
    isFree: false,
    downloadUrl: '/downloads/shsat-geometry.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=SHSAT%20geometry%20worksheet%20with%20shapes%2C%20area%20volume%20problems%2C%20coordinate%20planes%2C%20angle%20relationships%2C%20official%20SHSAT%20style%20format%2C%20professional%20test%20layout%2C%20clean%20background&width=400&height=500&seq=shsat03&orientation=portrait'
  },
  {
    id: 'shsat-word-problems',
    title: 'SHSAT Math: Word Problems',
    description: 'Master complex word problems and logical reasoning for SHSAT exam.',
    grade: 'SHSAT Prep',
    subject: 'Test Prep',
    topic: 'Problem Solving',
    difficulty: 'Advanced',
    pages: 10,
    isFree: false,
    downloadUrl: '/downloads/shsat-word-problems.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=SHSAT%20word%20problems%20worksheet%20with%20complex%20story%20problems%2C%20logical%20reasoning%2C%20multi%20step%20solutions%2C%20official%20SHSAT%20format%2C%20professional%20test%20design%2C%20clean%20organized%20background&width=400&height=500&seq=shsat04&orientation=portrait'
  },
  {
    id: 'shsat-practice-test',
    title: 'SHSAT Math: Full Practice Test',
    description: 'Complete SHSAT Math practice test with timing and answer explanations.',
    grade: 'SHSAT Prep',
    subject: 'Test Prep',
    topic: 'Full Test',
    difficulty: 'Advanced',
    pages: 20,
    isFree: false,
    downloadUrl: '/downloads/shsat-practice-test.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=SHSAT%20full%20practice%20test%20booklet%20cover%20with%20official%20style%20layout%2C%20comprehensive%20math%20section%2C%20answer%20sheet%2C%20professional%20standardized%20test%20format%2C%20clean%20white%20background&width=400&height=500&seq=shsat05&orientation=portrait'
  }
];